// extracted by mini-css-extract-plugin
export default {"recos":"N1-z","productCardOverride":"O1-z","rowHasBadge":"P1-z"};